




























import Vue from "vue";
import DropDownSimple from "@/components/dropdown/DropDownSimple.vue";
import ScriptCard from "./ScriptCard.vue";
import { state } from "./data/state";
import { UseModal } from "@/components/root/modal";
import CloudScriptModalVue from "./cloud-playbooks/cloud-script-modal/CloudScriptModal.vue";
import { BaseAppScript } from "./data/models";
import GenerateScriptModalVue from "./GenerateScriptModal.vue";
import { POLICY_SCRIPTS } from "./data/policy.scripts";
import { SharedState } from "@/common/state";
import PremiumModalVue from "@/components/premium/PremiumModal.vue";
import { onMounted } from "@vue/composition-api";
export default Vue.extend({
  components: {
    ScriptCard,
    //   DropDownSimple,
  },
  setup(_, { root: { $router } }) {
    const {
      scripts,

      data_sources,
      selected_source,
      set_selected_source,
    } = state;

    onMounted(() => {
      if (SharedState.is_biz_user.value) {
        $router.replace("/");
        return;
      }
      SharedState.onReady(() => {
        if (!SharedState.FeatureHelper.is_enabled("it_scripts")) {
          $router.replace("/");
        }
      });
    });

    const show_not_licensed_script_modal = (script: BaseAppScript) => {
      if (script.type == "policy") {
        UseModal().show(PremiumModalVue, {
          key: "securitypolicies-popup-2024",
        });
      } else {
        UseModal().show(PremiumModalVue, {
          key: "automatemicrosoftlabeling-popup-2024",
        });
      }
    };

    const show_script = async (script: BaseAppScript) => {
      if (script.is_not_licensed) {
        show_not_licensed_script_modal(script);
        return;
      }

      if (script.type === "policy") {
        await POLICY_SCRIPTS[script.id]();
      } else if (script.type === "cloud") {
        await UseModal().show(CloudScriptModalVue, {
          id: script.id,
        });
      } else {
        await UseModal().show(GenerateScriptModalVue, {
          id: script.id,
          type: script.type || "powershell",
        });
      }
    };

    return {
      scripts,
      data_sources,
      selected_source,
      set_selected_source,
      show_script,
    };
  },
});
